<h1 mat-dialog-title> 
    <button mat-icon-button mat-dialog-close (click)="close()" class="close" type="button">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg>
    </button>
</h1>
<div mat-dialog-content>
    <img src="../../../../assets/images/reset-password.png" class="icon" />

    <h1>Password Reset Required </h1>
    <p>As per our password reset policy, you are required to reset your password. A reset password link has been sent to your registered email address. Please follow the instructions in the email to update your password.</p>
    <p>If you do not receive the email or need help, please contact your agency staff for further assistance.</p>
</div>
